import React, { useCallback, useState } from "react";
import styles from "./tabs.modules.less";
import classNames from "classnames";
import IconCard from "../../image/card.svg";
import IconTable from "../../image/table.svg";
import { cj } from "../../utils/cls";

const Tabs = ({
  defaultActiveKey,
  items,
  onChangeTab,
  onChangeShowType,
  showListType,
}) => {
  const [activeKey, setActiveKey] = useState(+defaultActiveKey);
  const changeTab = (key) => {
    setActiveKey(key);
    onChangeTab(key);
  };
  const tabList = (items, activeKey) => {
    return items.map((item, index) => {
      const currentIndex = index + 1;
      return (
        <div
          key={item.key}
          className={classNames(styles.content, {
            [styles.tabActive]: activeKey === item.key,
          })}
          onClick={() => changeTab(item.key)}
        >
          {item.label}
        </div>
      );
    });
  };

  const item = items.filter((item) => item.key === activeKey);
  const children = item[0].children;

  return (
    <div className={styles.wrapper}>
      <div className={styles.tabsContainer}>
        {tabList(items, activeKey)}
        {/* <div className={styles.operator}>
          <IconCard
            className={
              showListType == "card"
                ? cj(styles.operatorIcon, styles.current)
                : styles.operatorIcon
            }
            alt="list"
            onClick={() => onChangeShowType("card")}
          />
          <IconTable
            className={
              showListType == "table"
                ? cj(styles.operatorIcon, styles.current)
                : styles.operatorIcon
            }
            alt="card"
            onClick={() => onChangeShowType("table")}
          />
        </div> */}
      </div>
      <div className={styles.tab_content}>{children}</div>
    </div>
  );
};
export default Tabs;
